import {gql} from '@apollo/client'

// Listagem de todos os empreendimentos
export const GET_EMPREENDIMENTOS = gql`
  query GetEmpreendimentos(
    $pagination: Pagination!
    $filtro: filter
    $situation: Float
    $orderBy: OrderByInput
  ) {
    GetEmpreendimentos(
      pagination: $pagination
      filtro: $filtro
      situation: $situation
      orderBy: $orderBy
    ) {
      pageInfo {
        currentPage
        totalPages
        totalItems
        hasNextPage
        hasPreviousPage
      }
      result {
        nome
        id
        endereco
        area_total_terreno
        area_total_privativa
        arquiteto
        parceiro
        parceiro_nome
        parceiro_percentual
        parceiro_percentual_proprio
        preco_medio_m2
        percentual_comissao
        responsavel
        situacao_id
        tag
        tipo_id
        user_id
        vgv
        vgv_proprio
        bloqueado
        setor_quadra
        created_at
        unidades
        ticket_medio_venda
        users {
          name
          id
        }
        empreendimento_terreno {
          terreno {
            id
            nome
            endereco
            numero
            zoneamento
            bairro
            latitude
            longitude
            marcacao
            cidade
            area_iptu
            operacao_urbana
            numero_contribuinte
            contaminacao
            melhoramento_viario
            desapropriacao
            patrimonio_cultural
            operacao_urbana
            terreno_situacao_cliente {
              id
              nome
              cor
            }
            users {
              id
              name
            }
          }
        }
        empreendimento_temperatura {
          id
          nome
          cor
        }
        empreendimento_situacao {
          id
          nome
          cor
        }
      }
    }
  }
`

export const GET_EMPREENDIMENTOS_RELATORIO_COMPLETO = gql`
  query GetEmpreendimentos(
    $pagination: Pagination!
    $filtro: filter
    $situation: Float
    $orderBy: OrderByInput
  ) {
    GetEmpreendimentos(
      pagination: $pagination
      filtro: $filtro
      situation: $situation
      orderBy: $orderBy
    ) {
      pageInfo {
        currentPage
        totalPages
        totalItems
        hasNextPage
        hasPreviousPage
      }
      result {
        nome
        id
        endereco
       
        area_total_terreno
        area_total_privativa
        arquiteto
        parceiro
        parceiro_nome
        parceiro_percentual
        parceiro_percentual_proprio
        preco_medio_m2
        percentual_comissao
        responsavel
        situacao_id
        tag
        tipo_id
        user_id
        vgv
        vgv_proprio
        bloqueado
        setor_quadra
        created_at
        vgv_vp
        terreno_em_dinheiro
        users {
          name
          id
        }
        empreendimento_terreno {
          terreno {
            id
            nome
            endereco
            numero
            cep
            bairro
            zoneamento
            bairro
            latitude
            longitude
            marcacao
            cidade
            area_iptu
            operacao_urbana
            numero_contribuinte
            contaminacao
            melhoramento_viario
            desapropriacao
            patrimonio_cultural
            operacao_urbana
            terreno_corretor {
              corretor {
                nome
                id
                telefone
              }
            }
            terreno_situacao_cliente {
              id
              nome
              cor
            }
            users {
              id
              name
            }
          }
        }
        empreendimento_temperatura {
          id
          nome
          cor
        }
        empreendimento_situacao {
          id
          nome
          cor
        }
      }
    }
  }
`

// Listagem de todos os empreendimentos
export const GET_EMPREENDIMENTOS_MAPA = gql`
  query GetEmpreendimentosMapa($pagination: Pagination!, $filtro: filter, $situation: Float) {
    GetEmpreendimentosMapa(pagination: $pagination, filtro: $filtro, situation: $situation) {
      pageInfo {
        currentPage
        totalPages
        totalItems
        hasNextPage
        hasPreviousPage
      }
      result {
        nome
        id
        endereco
        area_total_terreno
        area_total_privativa
        arquiteto
        parceiro
        parceiro_nome
        parceiro_percentual
        parceiro_percentual_proprio
        preco_medio_m2
        percentual_comissao
        responsavel
        situacao_id
        tag
        tipo_id
        user_id
        vgv
        unidades
        ticket_medio_venda
        users {
          name
          id
        }
        empreendimento_terreno {
          terreno {
            id
            nome
            endereco
            numero
            zoneamento
            bairro
            latitude
            longitude
            marcacao
            cidade
            operacao_urbana
            numero_contribuinte
            terreno_situacao_cliente {
              id
              nome
              cor
            }

            users {
              id
              name
            }
          }
        }
        empreendimento_temperatura {
          id
          nome
          cor
        }
        empreendimento_situacao {
          id
          nome
          cor
        }
      }
    }
  }
`

export const GET_EMPREENDIMENTOS_OFF = gql`
  query GetEmpreendimentosOff($pagination: Pagination!) {
    GetEmpreendimentosOff(pagination: $pagination) {
      id
      nome
      endereco
    }
  }
`

export const GET_EMPREENDIMENTOS_HISTORICO_RESPONSAVEIS = gql`
  query GetEmpreendimentosHistoricoResponsaveis($idEmpreendimento: Float!) {
    GetEmpreendimentosHistoricoResponsaveis(id_empreendimento: $idEmpreendimento) {
      result {
        id_empreendimento
        motivo
        data_cadastro
        usuarioAlteracao {
          id
          name
        }
        usuarioAntigo {
          id
          name
        }
        usuarioNovo {
          id
          name
        }
      }
    }
  }
`

export const GET_EMPREENDIMENTOS_MOTIVO_DESCARTE = gql`
  query GetEmpreendimentosMotivoDescarte($idEmpreendimento: Float!, $pagination: Pagination) {
    GetEmpreendimentosMotivoDescarte(
      id_empreendimento: $idEmpreendimento
      pagination: $pagination
    ) {
      pageInfo {
        currentPage
        totalPages
        totalItems
        hasNextPage
        hasPreviousPage
      }
      result {
        users {
          id
          name
        }
        data_cadastro
        motivo
        id_empreendimento
        id
      }
    }
  }
`

// Listagem de um unico empreendimento
export const GET_EMPREENDIMENTO = gql`
  query GetEmpreendimento($idEmpreendimento: Float!) {
    GetEmpreendimento(id_empreendimento: $idEmpreendimento) {
      id
      uuid
      nome
      situacao_id
      endereco
      area_total_privativa
      area_total_terreno
      preco_medio_m2
      arquiteto
      vgv
      responsavel
      tag
      parceiro_nome
      parceiro_percentual
      parceiro_percentual_proprio
      preco_m2_venda
      percentual_comissao
      vgv_proprio
      bloqueado
      unidades
      ticket_medio_venda
      vgv_vp
      terreno_em_dinheiro
      created_at
      empreendimento_temperatura {
        id
        nome
        cor
      }
      users {
        id
        name
      }

      empreendimento_terreno {
        terreno {
          lote
          endereco
          numero
          zona
          contaminacao
          melhoramento_viario
          desapropriacao
          patrimonio_cultural
          operacao_urbana
        }
      }
    }
  }
`
// Listagem de todos os empreendimentos
export const GET_COUNT_EMPREENDIMENTOS = gql`
  query GetCountEmpreendimentos {
    CountEmpreendimentos
  }
`

export const GET_EMPREENDIMENTOS_MESMA_QUADRA = gql`
  query GetEmpreendimentosMesmaQuadra($setorquadra: String) {
    GetEmpreendimentosMesmaQuadra(setorquadra: $setorquadra) {
      id
      endereco
      nome
      user_id
      users {
        id
        name
      }
    }
  }
`

export const GET_RELATORIO_EMPREENDIMENTOS_MESMA_QUADRA = gql`
  query GetRelatorioEmpreendimentosMesmaQuadra {
    GetRelatorioEmpreendimentosMesmaQuadra {
      id
      nome
      bairro
      nome_usuario
      qtde
      setor_quadra
      temperatura
      temperatura_cor
      situacao
      data_cadastro
    }
  }
`
